import { styled } from '@mui/material/styles';
import Section from './Section';
import { FormattedMessage } from 'react-intl';
import ListItemButton from '@mui/material/ListItemButton';
import Checkbox from '@/components/Checkbox/Checkbox';
import { GameStatuses } from '@/constants/GameStatuses';
import { useQuery } from '@tanstack/react-query';
import { fetchConfig } from '@/lib/api';
import FilterOptionsUnavailable from './FilterOptionsUnavailable';
import { mapConfigToOptions } from '@/lib/listOptions';

const GameStatus = ({
  value,
  onChange,
  mode = 'light',
}: {
  value: string[];
  onChange: (values: string[]) => void;
  mode?: 'light' | 'dark';
}) => {
  const { data, isError } = useQuery({
    queryKey: ['config'],
    queryFn: fetchConfig,
  });
  const gameStatusItems = mapConfigToOptions(
    GameStatuses,
    data?.filters.gameStatus?.filter((s) => s?.name !== 'disabled'),
  );

  const handleToggle = (selectedId: string | number) => () => {
    const currentIndex = value.findIndex((v) => v === selectedId);
    const newChecked = [...value];

    if (currentIndex === -1) {
      newChecked.push(selectedId as string);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    onChange(newChecked);
  };

  return (
    <Section
      title={
        <FormattedMessage
          id="gameStatus"
          defaultMessage="Game Status"
        />
      }
      aria-label="Game status filter"
      mode={mode}
      defaultOpen={value.length > 0}
    >
      {isError && !data ? (
        <FilterOptionsUnavailable />
      ) : (
        gameStatusItems.map(({ id, label }) => (
          <StyledButton
            key={id}
            onClick={handleToggle(id)}
            aria-label={`Toggle ${id} status`}
          >
            <StyledCheckbox
              checked={value.includes(id as string)}
              mode={mode}
            />
            <Label>{label}</Label>
          </StyledButton>
        ))
      )}
    </Section>
  );
};

const StyledButton = styled(ListItemButton)({
  padding: '4px 0',
});

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: `0 ${theme.spacing(1)} 0 0`,
}));

const Label = styled('div')({
  fontSize: 14,
});

export default GameStatus;
